module.exports = __webpack_public_path__ + "img/en.2822f086.png";